export const EmptyState = ({ icon: Icon, title, hint, children, testId }) => (
  <div className="flex flex-col items-center justify-center text-center py-14 px-6" data-testid={testId}>
    {Icon && (
      <div className="w-12 h-12 rounded-xl bg-secondary grid place-items-center mb-4">
        <Icon className="h-6 w-6 text-muted-foreground/60" strokeWidth={1.5} />
      </div>
    )}
    <p className="font-medium text-[15px]">{title}</p>
    {hint && <p className="mt-1 text-sm text-muted-foreground max-w-xs">{hint}</p>}
    {children && <div className="mt-4">{children}</div>}
  </div>
);
